import { DataManager } from '@syncfusion/ej2-data';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { AssetStoragePermissionGroupDTO, CreateAssetStoragePermissionGroupDTO, UpdateAssetStoragePermissionGroupDTO } from 'src/app/base/models/models.swagger.generated';
import { AssetSettingsService } from './asset-settings.service';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ModalService } from 'src/app/base/shared/modal/modal.service';
import { PermissionGroupFormComponent } from './permission-group-form/permission-group-form.component';
import { PermissionGroupUserAssignmentComponent } from './permission-group-user-assignment/permission-group-user-assignment.component';

import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-asset-settings',
    templateUrl: './asset-settings.component.html',
    styleUrls: ['./asset-settings.component.scss'],
    imports: [TitleBarComponent, GridModule, QueryBuilderModule, PermissionGroupUserAssignmentComponent, DialogModule, PermissionGroupFormComponent, TranslateModule],
    providers: [AssetSettingsService]
})
export class AssetSettingsComponent extends GridBaseComponent<any> implements OnInit {

  @ViewChild('groupDialog') public groupDialog: DialogComponent;

  public permissionGroup: AssetStoragePermissionGroupDTO;
  public permissionGroupForm: UntypedFormGroup;

  public hasChanges: boolean = false;
  public dataChanged() {
    this.hasChanges = true;
  };

  public customEditSettings = {
    allowEditing: false,
    allowAdding: true,
    allowDeleting: false,
    mode: 'Dialog',
    showDeleteConfirmDialog: true
  };

  constructor(
    translateService: TranslateService,
    protected assetSettingsService: AssetSettingsService,
    protected spinnerService: SpinnerService,
    private fb: UntypedFormBuilder,
    private modalService: ModalService,
  ) {
    super(translateService, assetSettingsService);
    this.addIndexFindColumnName = 'id';
  }

  ngOnInit() {
    this.permissionGroupForm = this.fb.group({
      name: [null, Validators.required]
    });

    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.assetSettingsService, this.spinnerService),
    });
    this.refresh();
  }

  public addPermissionGroup() {
    this.groupDialog.show();
  }

  public onSave() {
    const dto = {
      id: this.permissionGroup.id,
      name: this.permissionGroup.name,
      users: this.permissionGroup.users.map((user) => {
        return {
          userId: user.userId
        }
      })
    } as UpdateAssetStoragePermissionGroupDTO;
    this.assetSettingsService.updateRecord(dto).subscribe((pg: AssetStoragePermissionGroupDTO) => {
      this.permissionGroup = pg;
      this.grid.refresh();
      this.hasChanges = false;
    });
  }

  public deletePermissionGroup() {
    const dialog = this.modalService.showOkCancelDialog('i18n.domain.assets.asset-storage-settings.overview.delete-dialog.title', 'i18n.domain.assets.asset-storage-settings.overview.delete-dialog.question');
    dialog.onOkSubject.subscribe(() => {
      this.assetSettingsService.deleteRecord(this.permissionGroup.id).subscribe(() => {
        this.grid.refresh();
        this.permissionGroup = null;
      });
    });
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    this.permissionGroup = args.data as AssetStoragePermissionGroupDTO;
  }

  protected initializeEditForm(data: AssetStoragePermissionGroupDTO): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public okClicked(): void {
    if (this.permissionGroupForm.invalid) {
      return;
    }
    const dto = {
      name: this.permissionGroupForm.value.name
    } as CreateAssetStoragePermissionGroupDTO;

    this.assetSettingsService.addRecord(dto).subscribe((record: AssetStoragePermissionGroupDTO) => {
      this.permissionGroupForm.reset();
      this.permissionGroup = record;
      this.groupDialog.hide();
      this.grid.refresh();
    });

  }

  public cancelClicked(): void {
    this.groupDialog.hide();
  }

  public refresh(): void {
    this.grid?.refresh();
  }

  public override actionComplete(args: any) {
    if (((args as any).requestType === 'beginEdit' || (args as any).requestType === 'add')) {
      const dialog = (args as any).dialog;
      dialog.contentEle.style.paddingTop = '25px';
      dialog.width = 400;
      // change the header of the dialog
      dialog.header = (args as any).requestType === 'beginEdit' ? this.translateService.instant('i18n.domain.assets.asset-storage-settings.form.rename-dialog-title') : 'New Group';
    }
    // if a permission group is selected, select it again after refresh
    if(this.permissionGroup) {
      var index = this.grid.getRowIndexByPrimaryKey(this.permissionGroup.id);
      this.grid.selectRow(index);
    }
  }
}
